import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useState } from "react";
import { getPostsByPage, getPageCount } from "../globals";
import Heading from "../components/individuals/Heading";
import FadeInSection, {
  FadeInType,
} from "../components/wrappers/FadeInSection";

export default function ArticleList() {
  const [page, setPage] = useState(0);
  let paginationElems = [
    <li className="px-1 sm:px-[6px]" key="prev">
      <button
        onClick={() => (page === 0 ? () => {} : setPage(page - 1))}
        className={
          "hover:bg-primary flex h-9 items-center justify-center rounded-sm bg-[#2C3443] px-3 py-2 text-base font-medium text-white sm:h-10 sm:px-4 " +
          (page === 0 ? "hidden" : "")
        }
      >
        <span>
          <svg
            width="8"
            height="15"
            viewBox="0 0 8 15"
            className="fill-current stroke-current"
          >
            <path
              d="M7.12979 1.91389L7.1299 1.914L7.1344 1.90875C7.31476 1.69833 7.31528 1.36878 7.1047 1.15819C7.01062 1.06412 6.86296 1.00488 6.73613 1.00488C6.57736 1.00488 6.4537 1.07206 6.34569 1.18007L6.34564 1.18001L6.34229 1.18358L0.830207 7.06752C0.830152 7.06757 0.830098 7.06763 0.830043 7.06769C0.402311 7.52078 0.406126 8.26524 0.827473 8.73615L0.827439 8.73618L0.829982 8.73889L6.34248 14.6014L6.34243 14.6014L6.34569 14.6047C6.546 14.805 6.88221 14.8491 7.1047 14.6266C7.30447 14.4268 7.34883 14.0918 7.12833 13.8693L1.62078 8.01209C1.55579 7.93114 1.56859 7.82519 1.61408 7.7797L1.61413 7.77975L1.61729 7.77639L7.12979 1.91389Z"
              stroke-width="0.3"
            ></path>
          </svg>
        </span>
      </button>
    </li>,
    <li className="px-1 sm:px-[6px]" key="next">
      <button
        onClick={() =>
          page === getPageCount() - 1 ? () => {} : setPage(page + 1)
        }
        className={
          "hover:bg-primary flex h-9 items-center justify-center rounded-sm bg-[#2C3443] px-3 py-2 text-base font-medium text-white sm:h-10 sm:px-4 " +
          (page === getPageCount() - 1 ? "hidden" : "")
        }
      >
        <span>
          <svg
            width="8"
            height="15"
            viewBox="0 0 8 15"
            className="fill-current stroke-current"
          >
            <path
              d="M0.870212 13.0861L0.870097 13.086L0.865602 13.0912C0.685237 13.3017 0.684716 13.6312 0.895299 13.8418C0.989374 13.9359 1.13704 13.9951 1.26387 13.9951C1.42264 13.9951 1.5463 13.9279 1.65431 13.8199L1.65436 13.82L1.65771 13.8164L7.16979 7.93248C7.16985 7.93243 7.1699 7.93237 7.16996 7.93231C7.59769 7.47923 7.59387 6.73477 7.17253 6.26385L7.17256 6.26382L7.17002 6.26111L1.65752 0.398611L1.65757 0.398563L1.65431 0.395299C1.454 0.194997 1.11779 0.150934 0.895299 0.373424C0.695526 0.573197 0.651169 0.908167 0.871667 1.13067L6.37922 6.98791C6.4442 7.06886 6.43141 7.17481 6.38592 7.2203L6.38587 7.22025L6.38271 7.22361L0.870212 13.0861Z"
              stroke-width="0.3"
            ></path>
          </svg>
        </span>
      </button>
    </li>,
  ];
  for (let i = 1; i <= getPageCount(); i++) {
    if (page + 1 === i) {
      paginationElems.splice(
        paginationElems.length - 1,
        0,
        <li className="px-1 sm:px-[6px]" key={i}>
          <button
            disabled
            onClick={() => setPage(i - 1)}
            className="bg-primary flex h-9 items-center justify-center rounded-sm px-3 py-2 text-base font-medium text-white sm:h-10 sm:px-4"
          >
            {i}
          </button>
        </li>
      );
      continue;
    }
    paginationElems.splice(
      paginationElems.length - 1,
      0,
      <li className="px-1 sm:px-[6px]" key={i}>
        <button
          onClick={() => setPage(i)}
          className="hover:bg-primary flex h-9 items-center justify-center rounded-sm bg-[#2C3443] px-3 py-2 text-base font-medium text-white sm:h-10 sm:px-4 cursor-pointer"
        >
          {i}
        </button>
      </li>
    );
  }
  return (
    <div className="w-full h-full">
      <Navbar />
      <section id="blog" className="pt-[120px] relative z-40">
        <FadeInSection distance={FadeInType.FADEONLY}>
          <Heading heading="Articles" className="text-center" />
        </FadeInSection>
        <div className="px-4 mx-auto w-5/6 xl:w-3/5 mt-5">
          <div className="w-full border-b pb-20 dark:border-[#2E333D]">
            <div className="-mx-4 flex flex-wrap">
              {getPostsByPage(page).map((post, index) => (
                <div className="w-full px-4 md:w-1/2 lg:w-1/3">
                  <FadeInSection key={index} distance={FadeInType.SHORT}>
                    <div className="mb-10">
                      <div className="relative mb-8 overflow-hidden rounded-sm">
                        <a
                          href={"/articles/" + post.date}
                          className="block aspect-4/3"
                        >
                          <img
                            src={post.imagePath}
                            alt="blog-image"
                            className="object-cover aspect-4/3"
                          />
                        </a>
                        <span className="bg-primary font-main absolute top-5 left-5 rounded-sm px-4 py-[6px] text-sm font-medium text-white">
                          {post.postType}
                        </span>
                      </div>
                      <div>
                        <div className="mb-4 flex items-center">
                          <p className="font-main text-dark-text flex items-center pr-5 text-base">
                            <span className="pr-2">
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                className="fill-current"
                              >
                                <path d="M15 16.5H13.5V15C13.5 14.4033 13.2629 13.831 12.841 13.409C12.419 12.9871 11.8467 12.75 11.25 12.75H6.75C6.15326 12.75 5.58097 12.9871 5.15901 13.409C4.73705 13.831 4.5 14.4033 4.5 15V16.5H3V15C3 14.0054 3.39509 13.0516 4.09835 12.3484C4.80161 11.6451 5.75544 11.25 6.75 11.25H11.25C12.2446 11.25 13.1984 11.6451 13.9016 12.3484C14.6049 13.0516 15 14.0054 15 15V16.5ZM9 9.75C8.40905 9.75 7.82389 9.63361 7.27792 9.40746C6.73196 9.18131 6.23588 8.84984 5.81802 8.43198C5.40015 8.01412 5.06869 7.51804 4.84254 6.97208C4.6164 6.42611 4.5 5.84095 4.5 5.25C4.5 4.65905 4.6164 4.07389 4.84254 3.52793C5.06869 2.98196 5.40015 2.48588 5.81802 2.06802C6.23588 1.65016 6.73196 1.31869 7.27792 1.09254C7.82389 0.866396 8.40905 0.75 9 0.75C10.1935 0.75 11.3381 1.22411 12.182 2.06802C13.0259 2.91193 13.5 4.05653 13.5 5.25C13.5 6.44348 13.0259 7.58807 12.182 8.43198C11.3381 9.2759 10.1935 9.75 9 9.75ZM9 8.25C9.79565 8.25 10.5587 7.93393 11.1213 7.37132C11.6839 6.80871 12 6.04565 12 5.25C12 4.45435 11.6839 3.69129 11.1213 3.12868C10.5587 2.56607 9.79565 2.25 9 2.25C8.20435 2.25 7.44129 2.56607 6.87868 3.12868C6.31607 3.69129 6 4.45435 6 5.25C6 6.04565 6.31607 6.80871 6.87868 7.37132C7.44129 7.93393 8.20435 8.25 9 8.25Z"></path>
                              </svg>
                            </span>
                            {post.location}
                          </p>
                          <p className="font-main text-dark-text flex items-center text-base">
                            <span className="pr-2">
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                className="fill-current"
                              >
                                <path d="M12.75 2.25H15.75C15.9489 2.25 16.1397 2.32902 16.2803 2.46967C16.421 2.61032 16.5 2.80109 16.5 3V15C16.5 15.1989 16.421 15.3897 16.2803 15.5303C16.1397 15.671 15.9489 15.75 15.75 15.75H2.25C2.05109 15.75 1.86032 15.671 1.71967 15.5303C1.57902 15.3897 1.5 15.1989 1.5 15V3C1.5 2.80109 1.57902 2.61032 1.71967 2.46967C1.86032 2.32902 2.05109 2.25 2.25 2.25H5.25V0.75H6.75V2.25H11.25V0.75H12.75V2.25ZM11.25 3.75H6.75V5.25H5.25V3.75H3V6.75H15V3.75H12.75V5.25H11.25V3.75ZM15 8.25H3V14.25H15V8.25Z"></path>
                              </svg>
                            </span>
                            {new Date(
                              post.date + "T00:00:00"
                            ).toLocaleDateString("en-US", {
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                            })}
                          </p>
                        </div>
                        <h3>
                          <a
                            href={"/articles/" + post.date}
                            className="font-main text-dark hover:text-primary dark:hover:text-primary text-xl font-medium md:text-2xl lg:text-xl xl:text-2xl dark:text-white"
                          >
                            {post.title}
                          </a>
                        </h3>
                      </div>
                    </div>
                  </FadeInSection>
                </div>
              ))}
            </div>

            <div className="flex items-center justify-center pt-10">
              <ul className="-mx-1 flex items-center sm:-mx-[6px]">
                {paginationElems}
              </ul>
            </div>
          </div>
        </div>
        <div className="absolute top-0 right-0 -z-10">
          <svg
            width="1200"
            height="900"
            viewBox="0 0 1100 900"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g opacity="0.3" filter="url(#filter1)">
              <rect
                x="300"
                y="-3.65"
                width="629.62"
                height="757"
                transform="rotate(-40.44 463.78 -125.739)"
                fill="url(#grad1)"
              ></rect>
            </g>
            <defs>
              <filter
                id="filter1"
                x="0.0878906"
                y="-776.711"
                width="1726.24"
                height="1876.4"
                filterUnits="userSpaceOnUse"
              >
                <feFlood floodOpacity="0" result="BackgroundImage"></feFlood>
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImage"
                  result="shape"
                ></feBlend>
                <feGaussianBlur stdDeviation="225"></feGaussianBlur>
              </filter>
              <linearGradient
                id="grad1"
                x1="420.6"
                y1="60.5"
                x2="960.732"
                y2="623.2"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#ABBCFF"></stop>
                <stop offset="0.912" stopColor="#4A6CF7"></stop>
              </linearGradient>
            </defs>
          </svg>
        </div>
        <div className="absolute bottom-0 left-0 -z-10">
          <svg
            width="1460"
            height="500"
            viewBox="0 0 1460 500"
            fill="none"
            className="overflow-visible"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g opacity="0.3" filter="url(#filter2)">
              <rect y="460" width="1020" height="250" fill="url(#grad2)"></rect>
            </g>
            <defs>
              <filter
                id="filter2"
                x="-440"
                y="10"
                width="2000"
                height="1050"
                filterUnits="userSpaceOnUse"
              >
                <feFlood floodOpacity="0" result="BackgroundImage"></feFlood>
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImage"
                  result="shape"
                ></feBlend>
                <feGaussianBlur stdDeviation="225"></feGaussianBlur>
              </filter>
              <linearGradient
                id="grad2"
                x1="-94.8"
                y1="510.634"
                x2="-63.3028465"
                y2="810.234"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#ABBCFF"></stop>
                <stop offset="0.8453" stopColor="#4A6CF7"></stop>
              </linearGradient>
            </defs>
          </svg>
        </div>
      </section>
      <Footer />
    </div>
  );
}
